import React from 'react'
import Link from 'gatsby-link'
import tw, {styled} from 'twin.macro'
import {GatsbyImage} from 'gatsby-plugin-image'

const Wrapper = styled.div`
  ${tw`px-8 md:px-16 md:pt-6`}
`

const Header = styled.div`
  ${tw`mb-8`}
`

const Title = styled.h1`
  ${tw`text-gray-lightest text-4xl leading-tight md:leading-tight tracking-tight font-bold `}
`

const Subtitle = styled.h2`
  ${tw`text-gray-lightest text-xl leading-tight md:leading-tight tracking-tight font-bold max-w-xs`}
`

const List = styled.ul`
  ${tw`border-t border-solid border-gray`}
`
const Item = styled.li``

const PostLink = styled(Link)`
  ${tw`block no-underline py-8 border-b border-gray 
  md:(grid grid-cols-6 transition-opacity duration-500)
  `}
  justify-items: baseline;
  grid-template-areas: 'date heading heading venue description description';
  grid-column-gap: 1.5em;

  &:hover {
    h2 {
      /* ${tw`text-blue-500`} */
      /* color: ${(props) => props.theme.colors.accent}; */
      /* opacity: 0.75; */
    }
    p {
      /* opacity: 0.75; */
    }
  }
  @media (hover: none) {
    h2 {
      /* color: ${(props) => props.theme.colors.text} !important; */
    }
    p {
      opacity: 1 !important;
    }
  }
`

const BlockItemVariants = {
  // Named class sets
  Blue: tw``,
  Green: tw``,
  Purple: tw``,
  GrayGreen: tw``,
  GrayPurple: tw``,
}

// const BlockItemVariants = {
//   // Named class sets
//   Blue: tw`text-blue-300 group-hocus:text-bluealt-500`,
//   Green: tw`text-leaf `,
//   Purple: tw`text-purple-light group-hocus:text-purple`,
//   GrayGreen: tw`text-leaf-dark`,
//   GrayPurple: tw`text-leaf-dark`,
// }
const Heading = styled.h2(() => [
  tw`transition-colors duration-500 mb-0 group-hover:text-blue-600 md:mb-0 text-xl leading-5 font-bold `,
  ({variant = 'GrayPurple'}) => BlockItemVariants[variant], // Grab the variant style via a prop
])

const Description = styled.p`
  ${tw`transition-colors group-hover:text-gray-light`}
  margin: 0 0 1rem 0;
  @media screen and (min-width: ${(props) => props.theme.responsive.medium}) {
    max-width: 700px;
    margin: 0;
    grid-area: description;
  }
`

const Venue = styled.p`
  ${tw`transition-colors group-hover:text-gray-light`}
  margin-top: 0;
  @media screen and (min-width: ${(props) => props.theme.responsive.medium}) {
    max-width: 700px;
    margin: 0;
    grid-area: venue;
  }
`

const Date = styled.p`
  ${tw`transition-colors group-hover:text-gray text-sm leading-tight text-gray-light mb-4 md:mb-0 `}
  /* font-size: 0.9em;
  opacity: 0.5; */
  @media screen and (min-width: ${(props) => props.theme.responsive.medium}) {
    grid-area: date;
  }
`

const ItemList = (props) => {
  return (
    <Wrapper>
      <Header>
        <Title>{props.title}</Title>
        {props.subtitle && <Subtitle>{props.subtitle}</Subtitle>}
      </Header>
      <List>
        {props.posts.map(({node: item}) => (
          <Item key={item.id}>
            <PostLink
              className="group"
              to={`/${props.parentslug}/${item.slug}/`}
            >
              <Heading variant={item.colourTheme}>{item.title}</Heading>
              {item.venue && <Venue>{item.venue}</Venue>}
              {item.eventDate && <Date>{item.eventDate}</Date>}
              <Description>{item.body.childMarkdownRemark.excerpt}</Description>
              {/* <GatsbyImage
                alt={item.cover.title}
                image={item.cover.gatsbyImageData}
              /> */}
            </PostLink>
          </Item>
        ))}
      </List>
    </Wrapper>
  )
}

export default ItemList
